import { Property } from "../../../gen/witbooking/backoffice/property/v1/establishment_api_pb";
import { Image } from "../../shared/widgets/ImageManager";

export const DEFAULT_TIME_ZONE = "Europe/Madrid";

export interface PropertyEntity
  extends Omit<Property.AsObject, "location" | "multimediaList" | "amenitiesList"> {
  locationSection?: string;
  contactSection?: string;
  country: string;
  city: string;
  address: string;
  zipCode: string;
  searchCoordinates?: {
    latitude: number;
    longitude: number;
    timeZone: string;
  };
  latitude: number;
  longitude: number;
  timeZone: string;
  multimediaList: Image[];
  amenitiesSection?: string;
  amenitiesList?: Record<
    string,
    { value: string; icon?: string; translations?: { locale: string; name: string }[] }
  >;
}
